// config

export default {
  openUrlPrefix: '', // 本地dev环境跨域，服务器端已经支持，这里暂时关掉 // openUrlPrefix: '/opens'
  apiUrl: '/api',
  loginUrl: process.env.BUILD_ENV === 'dist' ? 'https://v2.fangcloud.com/sso/login' : 'https://v2master.fangcloud.net/sso/login',
  logoutUrl: process.env.BUILD_ENV === 'dist' ? 'https://v2.fangcloud.com/sso/logout' : 'https://v2master.fangcloud.net/sso/logout',
  registerUrl: process.env.BUILD_ENV === 'dist' ? 'https://v2.fangcloud.com/sso/register' : 'https://v2master.fangcloud.net/sso/register',
  imageUrl: process.env.BUILD_ENV === 'dist' ? 'https://v2.fangcloud.com' : 'https://v2master.fangcloud.net',
  requestUrl: process.env.BUILD_ENV === 'dist' ? 'https://v2.fangcloud.com' : 'https://v2master.fangcloud.net',
  wxUrl: process.env.BUILD_ENV === 'dist' ? 'https://v2.fangcloud.com' : 'http://xiangyangyang.fangcloud.net',
  openRequestUrl: process.env.BUILD_ENV === 'dist' ? 'https://open.fangcloud.com' : 'https://open.fangcloud.net',
  moreShareUrl: process.env.BUILD_ENV === 'dist' ? 'https://v2.fangcloud.com/hera' : 'https://stargate.fangcloud.net/hera',
  enterprise_info: null,
  // { is_personal_user_enterprise, }
  user_info: null,
  csrf_token: null,
  auth_token: null,
  scenario: null,
  isOpenPlatformWithToken: null,
  // 开放平台相关配置
  openConfig: {
    origin: null,
    userName: null,
    productName: null,
    theme: null,
    confirmBtnText: null,
    selectFileMax: null,
    previewUserToken: null,
    uploadDestFolderId: null,
    uploadDestFolderPath: null
  },
  // 专有云开关控制
  viewConfig: {
    isYiqixieEnabled: true, // 一起写
    isWpsPreviewEnabled: true, // wps预览
    isVirusScanEnabled: true, // 查毒
    isH5HideShareLinkDownload: false, // 分享链接、下载, 默认不禁用
    isDlpEnabled: true, // dlp
    isComplainEnabled: true, // 举报
    isFileManagerEnabled: true, // 文件管理员,只有白名单
    is_changxie_edit_enabled: false // is_changxie_edit_enabled
  },
  sensitive_control_strategy: null,
  isSensitiveInfoDetectEnabled: false, // 当前企业是否开启敏感词检测白名单字段
  application_api_id: {
    ngm: '7b75ea69-37a9-48a3-9d15-2a144378ce15',
    xmd: '62856d47-3f2d-4ac9-bbb5-7ce7242efbf6'
  }
}
